import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { acBilet } from '../actions/acBilet';

import _ from 'underscore';
class SistemMulty extends React.Component {


    changeChecked(val, e) {
        // if (val.valid === true) {
        var values = {
            position: val.position,
            checked: val.checked,
            value: parseInt(e.target.value, 10),
            numereArr: val.numereArr,
            odds: val.odds,
            type: 'multy'
        }

        this.props.acBilet(['biletChecked', values])
        // }
    }
    checkedCheck(val, result) {
        var findSys = _.contains(result.checked, val);

        if (findSys === true) {
            return true
        }
        return false;

        //sanse castig
        // for (var i = 0; i <= result.checked.length; i++) {
        //     if (result.checked[i] === val) {
        //         return true;
        //     } else if ((result.checked[i] > 8) && (val === 8)) {
        //         return true;
        //     } else if (result.checked.length === 1) {
        //         if (result.checked[i] === 1 && result.checked[i] !== val) {
        //             return true
        //         } else {
        //             return false
        //         }
        //     }
        // }
        // return false;
    }
    fact(n) {
        var f = 1;
        for (var i = 2; i <= n; ++i)
            f *= i;
        return f;
    }
    comb(n, k) {
        var aux = 1;
        for (var i = k + 1; i <= n; ++i)
            aux *= i;
        return aux / this.fact(n - k);
    }
    nrPosibilitati(i2, nrLength) {
        var comb = this.comb(nrLength, i2)

        if (this.props.conSizeChange.appW <= 1588) {
            return "" + comb
        } else {
            if (nrLength === i2) {
                return "" + comb + " " + this.props.multiLang.pariu.txt + ""
            } else {
                return "" + comb + " " + this.props.multiLang.pariuri.txt + ""
            }
        }


    }
    sisteme() {
        var col1 = []
        this.props.biletVal.numereArr.map((val, i) => {
            if (i < this.props.biletVal.odds.length) {
                // var comb = this.comb(this.props.biletVal.numereArr.length, i + 1);
                // var proc = this.props.biletVal.odds[i] / comb
                // if (proc > 1.5) {
                col1.push(
                    <div className={(i % 2 === 0) ? 'left' : 'right'} key={val}>
                        <input
                            type="checkbox"
                            id={'c' + val.roundUnique + i}
                            value={i + 1}
                            checked={this.checkedCheck(i + 1, this.props.biletVal)}
                            onChange={this.changeChecked.bind(this, this.props.biletVal)}
                        />
                        <label htmlFor={'c' + val.roundUnique + i}>
                            <span className="cbox"></span>
                            <span>{i + 1}/{this.props.biletVal.numereArr.length}{' (' + this.nrPosibilitati(i + 1, this.props.biletVal.numereArr.length) + ')'}</span>
                            {/* /
                                                    <span>{this.props.biletVal.numereArr.length}</span>
                                                <span> {'(' + this.nrPosibilitati(i + 1, this.props.biletVal.numereArr.length) + ')'}</span> */}
                        </label>
                    </div>
                )
                // }
            }
            // for (var z = 0; z < col1.length; z++) {
            //     console.log('dddddd', col1[z].value);
            //     // if (col1[z]) {

            //     // }
            // }
            // if (_.first(col1)) {
            //     console.log('col1!!!', col1);
            // }
            return (col1)
        })


        return (
            <div className="sisteme">
                <div className="col1">{col1}</div>
            </div>
        )

    }
    render() {
        return (
            <div>
                {this.sisteme()}
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        clientProp: state.clientProp,
        multiLang: state.multiLang,
        conSizeChange: state.conSizeChange,
        bilete: state.bilete
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acBilet: acBilet
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SistemMulty);
